import { render } from "./AddEditTask.vue?vue&type=template&id=0b0de3f9&scoped=true"
import script from "./AddEditTask.vue?vue&type=script&lang=js"
export * from "./AddEditTask.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"
import "./AddEditTask.vue?vue&type=style&index=1&id=0b0de3f9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b0de3f9"]])

export default __exports__